"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var LftIconBase_1 = __importDefault(require("../LftIconBase"));
var chevron_right_1 = __importDefault(require("@lift/assets/dist/assets/globals/icons/chevron_right"));
var S = __importStar(require("./LftList.styles"));
var LftList = function (_a) {
    var _b, _c;
    var ariaDescribed = _a.ariaDescribed, ariaDisabled = _a.ariaDisabled, ariaLabel = _a.ariaLabel, bgColor = _a.bgColor, dataElement = _a.dataElement, dataInfo = _a.dataInfo, dataTestId = _a.dataTestId, description = _a.description, disabled = _a.disabled, id = _a.id, leadingIcon = _a.leadingIcon, tabIndex = _a.tabIndex, title = _a.title, trailingIcon = _a.trailingIcon, lftClick = _a.lftClick;
    var _handleClick = function (e) {
        lftClick && lftClick(e);
    };
    if (dataElement) {
        if (dataElement.includes('_')) {
            if (typeof window !== 'undefined' && (((_b = window.location.href) === null || _b === void 0 ? void 0 : _b.indexOf("localhost")) > -1 || ((_c = window.location.href) === null || _c === void 0 ? void 0 : _c.indexOf("dev")) > -1)) {
                console.warn('Não é necessário mais colocar o prefixo no atributo dataElement');
            }
        }
        else {
            dataElement = "button_".concat(dataElement);
        }
    }
    return ((0, jsx_runtime_1.jsxs)(S.Wrapper, __assign({ "aria-describedby": ariaDescribed, "aria-disabled": ariaDisabled, bgColor: bgColor, className: leadingIcon ? 'leading' : '', "data-element": dataElement, "data-info": dataInfo, "data-lift": "lft-list", "data-testid": dataTestId ? dataTestId : id && id, description: description, disabled: disabled, id: id, leadingIcon: leadingIcon, tabIndex: disabled ? -1 : tabIndex, title: title, trailingIcon: trailingIcon, onClick: _handleClick }, { children: [leadingIcon && (0, jsx_runtime_1.jsx)(LftIconBase_1.default, { bgColor: bgColor, icon: leadingIcon, size: 'md' }), (0, jsx_runtime_1.jsxs)(S.Text, __assign({ "aria-label": ariaLabel, bgColor: bgColor }, { children: [!!title && (0, jsx_runtime_1.jsx)("label", { children: title }), !!description && (0, jsx_runtime_1.jsx)("span", { children: description })] })), trailingIcon && (0, jsx_runtime_1.jsx)(LftIconBase_1.default, { bgColor: bgColor, icon: chevron_right_1.default, size: 'md' })] })));
};
exports.default = LftList;
